import { PrivateSession } from "./../../../generated/graphql";
import { gql } from "@apollo/client";

export const GetMeeting = gql`
  query GetMeeting($id: String!) {
    meetingOne(id: $id) {
      id
      imgUrl
      name
      duration
      isSelfEnroll
      description
      waitlistMax
      isWaitlistEnabled
      maxOccupancy
      startAt
      endAt
      series {
        id
        dows
        doms
        seriesInterval
        scheduleTo
        scheduleFrom
      }
      isPrivateSession
      session {
        id
        name
      }
      privateSession {
        id
        duration
      }
      attendees {
        id
        client {
          user {
            firstName
            lastName
          }
        }
      }
      service {
        id
        organizationService {
          name
        }
      }
      instructor {
        id
        user {
          firstName
          lastName
        }
      }
      room {
        id
        name
      }
      location {
        id
        name
      }
      attendances {
        id
        attendanceStatus
        attendee {
          id
          attendeeType
          client {
            id
            user {
              firstName
              lastName
            }
          }
        }
        isPaid
      }
      waitlistees {
        id
        client {
          id
          user {
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const getMeetings = gql`
  query getMeetings(
    $locationId: String!
    $endAt: DateTime
    $startAt: DateTime
  ) {
    meetingMany(locationId: $locationId, endAt: $endAt, startAt: $startAt) {
      id
      name
      startAt
      endAt
      room {
        id
        name
      }
      service {
        id
      }
      instructor {
        id
        user {
          firstName
          lastName
        }
      }
    }
  }
`;

// Calendar
export const GetCalendarFilterLoc = gql`
  query GetCalendarFilterLoc($locationId: String!) {
    calendarFilterLocation(locationId: $locationId) {
      id
      services {
        id
      }
      location {
        id
        name
      }
      instructors {
        id
      }
      rooms {
        id
      }
    }
  }
`;

export const GetEventDetail = gql`
  query GetEventDetail($id: String!) {
    meetingOne(id: $id) {
      id
      name
      isSelfEnroll
      description
      waitlistMax
      isWaitlistEnabled
      maxOccupancy
      startAt
      endAt
      instructor {
        user {
          profilePicUrl
          firstName
          lastName
        }
      }
      room {
        name
      }
      location {
        name
      }

      attendees {
        id
      }
      waitlistees {
        id
      }
      service {
        id
        imgUrl
        cost
        organizationService {
          name
        }
        product {
          id
        }
        location {
          id
        }
      }
      privateSession {
        id
        cost
        session {
          imageUrl
          name
        }
        product {
          id
          isTaxable
          taxRates {
            id
            taxRate
          }
        }
      }
    }
  }
`;

export const GetMeetingPage = gql`
  query GetMeetingPage(
    $pagination: PaginationInput!
    $startAt: DateTime
    $endAt: DateTime
  ) {
    meetingPage(pagination: $pagination, startAt: $startAt, endAt: $endAt) {
      items {
        maxOccupancy
        startAt
        id
        name
        imgUrl
        attendees {
          id
        }
      }
      totalRows
    }
  }
`;
